<template>
  <a :href="rowData.download" target="_blank">
    <i class="fa fa-download"></i>
  </a>
</template>

<script>
export default {
  name: 'DownloadColumn',
  props: {
    rowData: {
      type: Object,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
a {
  color: $main-dark;
  transition: color 0.2s ease;
}
a:hover {
  color: $main-light;
}
</style>
